const LIME_GREEN = {
  main: '#D6F337',
  '600': '#AED60E',
}

const GREEN = {
  '100': '#DCFAE6',
  '600': '#079455',
}

const YELLOW = {
  '100': '#FEF0C7',
  '600': '#DC6803',
}

const ALICE_BLUE = {
  main: '#F8FAFF',
  '100': '#EDEDF1FF',
}

const MIDNIGHT_BLUE = {
  main: '#021542',
  '100': '#1D2F57',
  '700': '#3525E5',
  lightBlue: 'rgba(178, 189, 214, 0.2)',
  primary: '#021542',
}

const WHITE = {
  main: '#fff',
  '100': '#F8FAFF',
}
const BLACK = {
  main: '#000',
}

const GREY_MUTED_TEXT = {
  main: '#8E94A3',
}

const GREY_MUTED_ICON = {
  main: '#9A9A9A',
}

const CORAL = {
  main: '#F46857',
  '600': '#d35647',
}

const RED = {
  main: '#F04438',
  '100': '#FEE4E2',
  '600': '#D92D20',
}

const ORANGE = {
  main: '#FEC84B',
  '100': '#ed6c02',
  orangeHover: '#e65100',
}

const GREY = {
  main: '#8E94A3',
  muted: '#8E94A3',
  shadowLight: 'rgba(0, 21, 70, .1)',
  buttonOutlineBorder: '#D4DBFF',
  buttonBackBg: 'rgba(255,255,255, .3)',
  buttonBackHover: 'rgba(255, 255, 255, 0.04)',
  descriptionLabel: '#969696',
  buttonLinkMuted: '#999',
  headerNavButtonBorder: '#364254',
  drawerTopLine: '#E8ECF2',
  inputBorder: '#B2BDD6',
  '100': '#F2F4F7',
  '200': '#EAECF0',
  '700': '#344054',
}

const BLUE = {
  main: '#1047CA',
  light: '#E4ECFF',
  lightGrayishBlue: '#E8ECF2',
  paleBlue: '#F8FAFF',
  lightSteelBlue: '#B2BDD6',
  '100': 'rgb(218, 228, 255)',
  '500': '#e4ecff',
  '600': '#1570EF',
  '700': '#1977D2',
  primaryLight: '#EAEEF9',
  primaryLightest: '#E4ECFFB2',
}

const BRAND = {
  '100': 'rgb(218, 228, 255)',
  '700': '#3525E5',
}

const PURPLE = {
  '100': '#EBE9FE',
  '600': '#6938EF',
}

export const myPalette = {
  limeGreen: LIME_GREEN,
  aliceBlue: ALICE_BLUE,
  midnightBlue: MIDNIGHT_BLUE,
  white: WHITE,
  black: BLACK,
  mutedText: GREY_MUTED_TEXT,
  dark: GREY,
  greyMutedIcon: GREY_MUTED_ICON,
  blue: BLUE,
  coral: CORAL,
  red: RED,
  orange: ORANGE,
  green: GREEN,
  yellow: YELLOW,
  brand: BRAND,
  purple: PURPLE,
}
